import { render, staticRenderFns } from "./RadioListSection.vue?vue&type=template&id=a99476b0&scoped=true"
import script from "./RadioListSection.vue?vue&type=script&lang=ts"
export * from "./RadioListSection.vue?vue&type=script&lang=ts"
import style0 from "./RadioListSection.vue?vue&type=style&index=0&id=a99476b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99476b0",
  null
  
)

export default component.exports